import * as React from 'react'

export const ColorIcon = React.memo(
  ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className} {...props}>
    <path d="M10.0031 9.99919L5.42054 0.832031L0.835938 9.99817" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.75 8.16358H9.08169" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6736 18.8377L18.8411 12.6702C19.2791 12.2323 19.2791 11.5233 18.8411 11.0864L17.0637 9.30896C16.6257 8.87097 15.9168 8.87097 15.4798 9.30896L9.31236 15.4764C9.10151 15.6873 8.98438 15.9714 8.98438 16.2679V19.1657H11.8822C12.1786 19.1657 12.4628 19.0486 12.6736 18.8377Z" fill="#1C274C" />
  </svg>
    )
  },
)

ColorIcon.displayName = 'ColorIcon'